var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{ref:"loading",staticClass:"loading-page"},[_c('div',{staticClass:"logo-center"},[_c('Logo')],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }